import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  teacher_flag: "N", // Default to not a teacher
};

const employeeSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    updateTeacherFlag: (state, action) => {
      state.teacher_flag = action.payload;
    },
    resetToInitialState: () => {
      return initialState;
    },
  },
});

export const { updateTeacherFlag, resetToInitialState } = employeeSlice.actions;

export default employeeSlice.reducer;
